<template>  
  <VUEModal :Titolo="Titolo" 
            :Programma="'DMSEW'"
            :Altezza="ObjXLSX.IsCampioniRilevati ? (parseInt(AltezzaPopup) + 80) + 'px' : AltezzaPopup" 
            :Larghezza="'900px'" 
            :PathLogo="require('@/assets/images/LogoDMS.png')"
            @onClickChiudiModal="OnClickChiudiModal">

    <template v-slot:Body>
      <VUEPopupDataAllineamento  v-if="PopupAllineamentoInclinazioni"
                                :ChiaveSito="ChiaveSito"
                                @onClickConfermaAllineamento="OnClickConfermaAllineamento"
                                @onClickAnnullaPopupAllineamento="OnClickAnnullaAllineamento"/>

      <VUEPopupDataAllineamento  v-if="PopupAllineamentoTemp"
                                :ChiaveSito="ChiaveSito"
                                @onClickConfermaAllineamento="OnClickConfermaAllineamentoTemp"
                                @onClickAnnullaPopupAllineamento="OnClickAnnullaAllineamentoTemp"/>

      <VUEPopupDataAllineamento  v-if="PopupAllineamentoDeformazioni"
                                :ChiaveSito="ChiaveSito"
                                @onClickConfermaAllineamento="OnClickConfermaAllineamentoDeformazioni"
                                @onClickAnnullaPopupAllineamento="OnClickAnnullaAllineamentoDeformazioni"/>

      <VUEModal v-if="PopupFiltroProfondita" :Titolo="this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_INT_TITOLO',this.LinguaUtente)" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'" :Altezza="'150px'" :Larghezza="'500px'"
                @onClickChiudiModal="AnnullaFiltroProfondita">
        <template v-slot:Body>
          <div style="float: left;font-size:14px;text-align: center;">
            <label>{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_INT_PROF_TESTO',this.LinguaUtente) }}:</label>
          </div>
          <div style="clear:both;height:4px"></div>
          <div style="clear:both;height:4px"></div>
          <div class="ZMDivPopupContent" style="width: 100%">
            <label class="ZMLabelDescriptionPopup">{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_INT_PROF_MIN',this.LinguaUtente) }}</label>
            <div style="width:20px;float:left">&nbsp;</div> 
            <input class="form-control" type="number" style="float: left; width: calc(50% - 20px)" v-model="Filtro.DallaProfondita">
          </div>
          <div style="clear:both;height:4px"></div>
          <div class="ZMDivPopupContent" style="width: 100%">
            <label class="ZMLabelDescriptionPopup">{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_INT_PROF_MAX',this.LinguaUtente) }}</label>
            <div style="width:20px;float:left">&nbsp;</div> 
            <input class="form-control" type="number" style="float: left; width: calc(50% - 20px)" v-model="Filtro.AllaProfondita">
          </div>
        </template>
        <template v-slot:Footer>
          <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:20%" @click="AnnullaFiltroProfondita" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
          <button v-if="(Filtro.DallaProfondita !== '') && (Filtro.AllaProfondita !== '')" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:20%" @click="ConfermaFiltroProfondita" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
        </template>
      </VUEModal>

      <div class="col-md-12">
        <div style="float:right;width:3%;">&nbsp;</div>

        <div style="float:right;width:8%">
          <select class="form-control" v-model="Filtro.OreAl">
          <option v-for="Ora in 24" 
                    :Key="Ora">{{ Ora -1 }}</option>  
          </select>
        </div> 
        <div style="float: right;font-size:14px;padding-top: 5px;width:4%;text-align: right; padding-right: 15px;min-width:103px">
          <label>{{ this.GetTraduzioneLabel('UdmGenerali','TKN_ORE_M',this.LinguaUtente) }}</label>
        </div>

        <div style="float:right;width:9%">
          <input type="date" class="form-control" style="min-width:132px" v-model="Filtro.AllaData"/>
        </div>
        <div style="float: right;font-size:14px;padding-top: 5px;width:7%;text-align: right; padding-right: 15px;">
          <label style="float:left;min-width:20px;width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_AL',this.LinguaUtente) }}</label>
        </div>
        <div style="float:right;width:8%">
          <select class="form-control" v-model="Filtro.OreDal">
          <option v-for="Ora in 24" 
                    :Key="Ora">{{ Ora - 1 }}</option>  
          </select>
        </div> 
        <div style="float: right;font-size:14px;padding-top: 5px;width:7%;text-align: right; padding-right: 15px;min-width:103px">
          <label>{{ this.GetTraduzioneLabel('UdmGenerali','TKN_ORE_M',this.LinguaUtente) }}</label>
        </div>

        <div style="float:right;width:9%">
          <input type="date" class="form-control" style="min-width:132px" v-model="Filtro.DallaData"/>
        </div>
        <div style="float: right;font-size:14px;padding-top: 5px;width:11%;text-align: right; padding-right: 15px;min-width:30px">
          <label>{{ this.GetTraduzioneLabel('Generic','TKN_STORICO_DAL',this.LinguaUtente) }}</label>
        </div>
        <div style="float:right;width:3%;">&nbsp;</div>
        <div style="clear:both;height:10px"></div>
      </div>



      <div class="col-md-12">
        <div style="float:left;width:3%;">&nbsp;</div>

        <div style="width:57%;float:left;">
          <div class="ZMSeparatoreScheda" style="margin-bottom:0px;margin-top:0px" :style="{'background-color' : ColoriPantone.Marrone }">
            <text style="font-weight: bold;">{{ this.GetTraduzioneLabel('Generic','TKN_MODULI',this.LinguaUtente) }}</text>
          </div>
          <div style="overflow:auto" :style="{'max-height': ObjXLSX.IsCampioniRilevati ? (parseInt(AltezzaPopup) - 20) + 'px' : (parseInt(AltezzaPopup) - 100) + 'px'}" >
            <template v-for="(OggettoModulo, index) in FiltraModuli" :key="index">
              <div style="background-color:white;">
                <div style="float:left;width:3%;">&nbsp;</div>
                <input style="float:left;width:3%;margin-top:4px;padding: 0px;height: 20px" type="checkbox" class="form-control" v-model="OggettoModulo.Selezionato"/>
                <div style="float:left;width:2%;">&nbsp;</div>
                <text style="float:left;width:92%;margin-top:6px;font-size:16px"> {{ this.GetTraduzioneLabel('Generic','TKN_MOD_N',this.LinguaUtente) }} {{ OggettoModulo.Id }}</text>
                <div style="clear:both"></div>
              </div>
            </template>
          </div>
        </div>
        
        <div style="float:left;width:2%;">&nbsp;</div>

        <div style="width:35%;float:left" ref="DivPulsanti">
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:96%">
            <button @click="OnClickSelezionaTuttiModuli" type="button" class="btn btn-info" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_TUTTI',this.LinguaUtente) }}</button>
          </div>
          <div style="clear:both;height:4px"></div>
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:96%">
            <button @click="OnClickDeselezionaTuttiModuli" type="button" class="btn btn-info" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_NESSUNO',this.LinguaUtente) }}</button>
          </div>
          <div style="clear:both;height:4px"></div>
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:96%">
            <button @click="OnClickInvertiTuttiModuli" type="button" class="btn btn-info" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_INVERTI',this.LinguaUtente) }}</button>
          </div>
          <div style="clear:both;height:4px"></div>
          <div style="float:left;width:4%;">&nbsp;</div>
          <div v-if="!FiltroProfonditaAttivo" style="float:left;width:96%">
            <button @click="OnClickPopupFiltroProfondita" type="button" class="btn btn-info" style="width:100%">{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_INT_PROF',this.LinguaUtente) }}</button>
          </div>
          <div v-else style="float:left;width:96%">
            <button @click="OnClickResetFiltroProfondita" type="button" class="btn btn-info" style="width:100%">{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_RESET_PROF',this.LinguaUtente) }}</button>
          </div>
          <div style="clear:both;height:10px"></div>

          <div v-if="ObjXLSX.IsCampioniRilevati">
            <div style="float:left;width:4%;">&nbsp;</div>
            <div style="float:left;width:6%;">
              <input style="float:left;height:100%" type="checkbox" class="form-control" v-model="Filtro.Piezometri"/>
            </div> 
            <div style="float:left;width:90%;">
              <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_PIEZOMETRI',this.LinguaUtente) }}</label>
            </div> 
            <div class="ZMDistanziatore"></div>
          </div>

          <div v-if="ObjXLSX.IsCampioniRilevati">
            <div style="float:left;width:4%;">&nbsp;</div>
            <div style="float:left;width:6%;">
              <input style="float:left;height:100%" type="checkbox" class="form-control" v-model="Filtro.Estensimetri"/>
            </div> 
            <div style="float:left;width:90%;">
              <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_ESTENSIMETRI',this.LinguaUtente) }}</label>
            </div> 
            <div class="ZMDistanziatore"></div>
          </div>

          <div v-if="ObjXLSX.IsCampioniRilevati">
            <div style="float:left;width:4%;">&nbsp;</div>
            <div style="float:left;width:6%;">
              <input style="float:left;height:100%" type="checkbox" class="form-control" v-model="ObjXLSX.TuttiIDati"/>
            </div> 
            <div style="float:left;width:90%;">
              <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('VuePopupXLSXDatiStorici','TKN_TUTTI_I_DATI',this.LinguaUtente) }}</label>
            </div> 
            <div class="ZMDistanziatore"></div>
          </div>

          <div v-if="ObjXLSX.IsCampioniRilevati && !ObjXLSX.TuttiIDati">
            <div style="width: 40%; float:left;">
              <label style="float:left;font-weight:bold;font-size:16px;margin-top: 3px;">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('VuePopupXLSXDatiStorici','TKN_MEDIA_OGNI',this.LinguaUtente) }}</label>
            </div> 
            <div style="width: 30%; float:left">
              <input style="float:left;height:100%" type="number" class="form-control" v-model="ObjXLSX.IntervalloMedia"/>
            </div> 
            <div style="width: 20%; float:left">
              <label style="float:left;font-weight:bold;font-size:16px;margin-top: 3px;">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('UdmGenerali','TKN_ORE_M',this.LinguaUtente) }}</label>
            </div> 
            <div class="ZMDistanziatore"></div>
          </div>

          <div class="col-md-12" style="float:right" v-if="false">
            <div>

              <div style="width:100%;float:left">
                <div class="ZMSeparatoreScheda" style="margin-bottom:0px;margin-top:0px; border-radius: 2px;" :style="{'background-color' : ColoriPantone.Marrone }">       
                  <text style="font-weight: bold;">{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_INCL',this.LinguaUtente) }}:</text>
                </div>
              </div>
              <div class="ZMDistanziatore"></div>

              <div style="width:100%;float:left" v-if="Filtro.AllineamentoIncl == null">
                <div style="margin-bottom:0px;margin-top:0px;text-align:center">  
                  <div class="ZMDistanziatore"></div>
                  <text style="font-weight: bold">{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_INCL_NON_ASS',this.LinguaUtente) }}</text>
                  <div class="ZMDistanziatore"></div>
                </div>
              </div>
              <div style="width:100%;float:left" v-else>
                <div style="margin-bottom:0px;margin-top:0px;text-align:center">       
                  <text style="font-weight: bold">{{ GestisciDateGrafica(Filtro.AllineamentoIncl.DataAllineamento) + ' ' + Filtro.AllineamentoIncl.OrarioAllineamento }}</text>
                </div>
              </div>
              <div class="ZMDistanziatore"></div>

              <div style="width:100%;float:left">
                <div style="margin-bottom:0px;margin-top:0px;text-align:center">       
                  <button @click="OnClickCancellaAllineamentoInclinazioni" type="button" class="btn btn-info" style="float:right;font-weight:bold;width:25%;font-size: 10px;" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
                  <button @click="OnClickVisualizzaAllineamentoInclinazioniAllaData" type="button" class="btn btn-info" style="float:right;font-weight:bold;width:25%;font-size: 10px;margin-right:20px;" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CAMBIA',this.LinguaUtente) }}</button>
                </div>
              </div>
              <div class="ZMDistanziatore"></div>
            </div>

            <div>
              <div style="width:100%;float:left">
                <div class="ZMSeparatoreScheda" style="margin-bottom:0px;margin-top:0px; border-radius: 2px;" :style="{'background-color' : ColoriPantone.Marrone }">       
                  <text style="font-weight: bold;">{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_TEMP',this.LinguaUtente) }}:</text>
                </div>
              </div>
              <div class="ZMDistanziatore"></div>

              <div style="width:100%;float:left" v-if="Filtro.AllineamentoTemp == null">
                <div style="margin-bottom:0px;margin-top:0px;text-align:center">
                  <div class="ZMDistanziatore"></div>       
                  <text style="font-weight: bold">{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_TEMP_NON_ASS',this.LinguaUtente) }}</text>
                  <div class="ZMDistanziatore"></div>
                </div>
              </div>
              <div style="width:100%;float:left" v-else>
                <div style="margin-bottom:0px;margin-top:0px;text-align:center">       
                  <text style="font-weight: bold">{{ GestisciDateGrafica(Filtro.AllineamentoTemp.DataAllineamento) + ' ' + Filtro.AllineamentoTemp.OrarioAllineamento }}</text>
                </div>
              </div>
              <div class="ZMDistanziatore"></div>

              <div style="width:100%;float:left">
                <div style="margin-bottom:0px;margin-top:0px;text-align:center">       
                  <button @click="OnClickCancellaAllineamentoTemp" type="button" class="btn btn-info" style="float:right;font-weight:bold;width:25%;font-size: 10px;" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
                  <button @click="OnClickVisualizzaAllineamentoTempAllaData" type="button" class="btn btn-info" style="float:right;font-weight:bold;width:25%;font-size: 10px;margin-right:20px;" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CAMBIA',this.LinguaUtente) }}</button>
                </div>
              </div>
              <div class="ZMDistanziatore"></div>
            </div>

            <div>
              <div style="width:100%;float:left">
                <div class="ZMSeparatoreScheda" style="margin-bottom:0px;margin-top:0px; border-radius: 2px;" :style="{'background-color' : ColoriPantone.Marrone }">       
                  <text style="font-weight: bold;">{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_DEF',this.LinguaUtente) }}:</text>
                </div>
              </div>
              <div class="ZMDistanziatore"></div>

              <div style="width:100%;float:left" v-if="Filtro.AllineamentoDef == null">
                <div style="margin-bottom:0px;margin-top:0px;text-align:center"> 
                  <div class="ZMDistanziatore"></div>      
                  <text style="font-weight: bold">{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_DEF_NON_ASS',this.LinguaUtente) }}</text>
                  <div class="ZMDistanziatore"></div>
                </div>
              </div>
              <div style="width:100%;float:left" v-else>
                <div style="margin-bottom:0px;margin-top:0px;text-align:center">       
                  <text style="font-weight: bold">{{ GestisciDateGrafica(Filtro.AllineamentoDef.DataAllineamento) + ' ' + Filtro.AllineamentoDef.OrarioAllineamento }}</text>
                </div>
              </div>
              <div class="ZMDistanziatore"></div>

              <div style="width:100%;float:left">
                <div style="margin-bottom:0px;margin-top:0px;text-align:center">       
                  <button @click="OnClickCancellaAllineamentoDeformazioni" type="button" class="btn btn-info" style="float:right;font-weight:bold;width:25%;font-size: 10px;" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
                  <button @click="OnClickVisualizzaAllineamentoDeformazioniAllaData" type="button" class="btn btn-info" style="float:right;font-weight:bold;width:25%;font-size: 10px;margin-right:20px;" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CAMBIA',this.LinguaUtente) }}</button>
                </div>
              </div>
              <div class="ZMDistanziatore"></div>
            </div>
          </div>

          <div v-if="!ObjXLSX.IsCampioniRilevati">
            <div style="float:left;width:4%;">&nbsp;</div>
            <div style="float:left;width:96%;">
              <div style="float:left;width:67%">
                <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px;margin-top:5px">{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_ORIENT_ASSE_N',this.LinguaUtente) }}</label>
              </div> 
              <div style="float:left;width:33%">
                <input step="0.01" style="float:left;" type="number" class="form-control" v-model="Filtro.OrientamentoAsse"/>
              </div> 
            </div>
            <div style="clear:both;height:10px"></div>
          </div>

          <div class="col-md-12" v-if="!ObjXLSX.IsCampioniRilevati">
            <div style="float:left;margin-top: 7px;font-weight:bold;font-size:16px;">{{ this.GetTraduzioneLabel('VuePopupXLSXDatiStorici','TKN_MEDIA_ORARIA',this.LinguaUtente) }}</div>
            <input style="float:left;margin:0px;width:15px;margin-left: 5px;" type="radio" name="MediaOraria" class="form-control" :value="true" v-model="ObjXLSX.MediaOraria"/>
            <div style="float:left;margin-left:30px;;margin-top: 7px;font-weight:bold;font-size:16px;">{{ this.GetTraduzioneLabel('VuePopupXLSXDatiStorici','TKN_MEDIA_GIORNALIERA',this.LinguaUtente) }}</div>
            <input style="float:left;width:15px;margin:0px;margin-left: 5px;" type="radio" name="MediaOraria" class="form-control" :value="false" v-model="ObjXLSX.MediaOraria"/>
          </div>

          <div class="col-md-12" v-if="!ObjXLSX.IsCampioniRilevati && ObjXLSX.MediaOraria" style="margin-top: 15px;">
            <div style="float:left;margin-top: 7px;font-weight:bold;font-size:16px;">{{ this.GetTraduzioneLabel('VuePopupXLSXDatiStorici','TKN_SOLO_TOTALE',this.LinguaUtente) }}</div>
            <input style="float:left;margin:0px;width:15px;margin-left: 10px; margin-top: 2px" type="checkbox" class="form-control" v-model="ObjXLSX.SoloTotale"/>
          </div>

        </div>

        <div style="float:left;width:3%;">&nbsp;</div>

        <div style="clear:both;height:4px"></div>

      </div>
    </template>
   
    <template  v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:20%" @click="OnClickChiudiModal" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="CanRecord()" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:20%" @click="OnClickConfermaModal"  data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
 
  </VUEModal>
</template>

<script>

import XLSX from 'xlsx-js-style/dist/xlsx.min.js'
import VUEModal from '@/utils/VUEModal.vue';            
import { COLORI_PANTONE, SystemInformation, TIPOLOGIA_GRAFICI_STORICI, SFONDO } from '@/SystemInformation'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import { TZDateFunct } from '@/utils/ZDateFunct.js'
import VUEPopupDataAllineamento from '../Popups/VUEPopupDataAllineamento.vue'
import MixInsDoubleClickHandler from '@/views/ContentPages/MixInsDoubleClickHandler';
export default 
{
  data()
  {
   return {
            ColoriPantone         : COLORI_PANTONE,
            ColoriSfondo          : SFONDO,
            TipologiaGrafici      : TIPOLOGIA_GRAFICI_STORICI,
            TipologiaPopup        : SystemInformation.TipoPopupAperto,
            Filtro                : {
                                      Piezometri           : false,
                                      Profondita           : false,
                                      Estensimetri         : false,
                                      AllaData             : '',
                                      OreDal               : 0,
                                      OreAl                : 23,
                                      DallaData            : '',
                                      DallaProfondita      : 0,
                                      AllaProfondita       : 0,
                                      VisualizzaMarkup     : false,
                                      InterpMinimiQuadrati : false,
                                      OrientamentoAsse     : 0,
                                      PeriodoMedia         : 0,
                                      AllineamentoIncl     : null, 
                                      AllineamentoTemp     : null,
                                      AllineamentoDef      : null,
                                    },
            GrandezzaDivPulsanti  : {
                                      Height : 0
                                    },
            URLSchedaStorici      : '/appMainWindow/GraficiStorici',

            FiltroProfonditaAttivo        : false,
            PopupFiltroProfondita         : false,
            PopupAllineamentoInclinazioni : false,
            PopupAllineamentoTemp         : false,
            PopupAllineamentoDeformazioni : false,
            LinguaUtente                  : SystemInformation.UserInformation.Lingua
          }
  },

  props : ['AltezzaPopup', 'Titolo', 'ObjXLSX', 'ChiaveSito', 'ChiaveCatena', 'DatiGenerici', 'IsEstensimetroPresente', 'DataCalibrazione'],
  emits : ['OnClickChiudiPopup'],
  mixins: [MixInsDoubleClickHandler, MixInsGestioneTraduzioni],
  components: { 
                VUEModal,
                VUEPopupDataAllineamento 
              },

  methods :
  {
    OnClickChiudiModal()
    {
      this.$emit('OnClickChiudiPopup')
    },

    OnClickVisualizzaAllineamentoInclinazioniAllaData()
    {
      this.PopupAllineamentoInclinazioni = true
    },
    OnClickConfermaAllineamento(OggettoData)
    {
      this.PopupAllineamentoInclinazioni = false
      this.Filtro.AllineamentoIncl       = OggettoData
    },
    OnClickAnnullaAllineamento()
    { 
      this.PopupAllineamentoInclinazioni = false
    },
    OnClickCancellaAllineamentoInclinazioni()
    {
      this.Filtro.AllineamentoIncl = null
    },


    OnClickVisualizzaAllineamentoTempAllaData()
    {
      this.PopupAllineamentoTemp = true
    },
    OnClickConfermaAllineamentoTemp(OggettoData)
    {
      this.PopupAllineamentoTemp   = false
      this.Filtro.AllineamentoTemp = OggettoData
    },
    OnClickAnnullaAllineamentoTemp()
    { 
      this.PopupAllineamentoTemp = false
    },
    OnClickCancellaAllineamentoTemp()
    {
      this.Filtro.AllineamentoTemp = null
    },


    OnClickVisualizzaAllineamentoDeformazioniAllaData()
    {
      this.PopupAllineamentoDeformazioni = true
    },
    OnClickConfermaAllineamentoDeformazioni(OggettoData)
    {
      this.PopupAllineamentoDeformazioni = false
      this.Filtro.AllineamentoDef        = OggettoData
    },
    OnClickAnnullaAllineamentoDeformazioni()
    { 
      this.PopupAllineamentoDeformazioni = false
    },
    OnClickCancellaAllineamentoDeformazioni()
    {
      this.Filtro.AllineamentoDef = null
    },

    EsportaExcelCampioniRilevati(Dati)
    {
      const wb = XLSX.utils.book_new();
      for (let i = 0; i < Dati.length; i++)
      {
        for (let j = 0; j < Dati[i].Grafici.length; j++)
        {
          let SingleModulo = Dati[i].Grafici[j]
          let ArrayContenitore = []
          let DatiGenerali = this.DatiGenerici
          let RigaIntestazione = [{v: this.GetTraduzioneLabel('Generic','TKN_DMS',this.LinguaUtente) + " " + DatiGenerali.DESCRIZIONE, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}}]
          ArrayContenitore.push(RigaIntestazione)
          RigaIntestazione = [{v:  Dati[0].Intervallo, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}}]
          ArrayContenitore.push(RigaIntestazione)
          RigaIntestazione = [{v: this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_PROGETTO',this.LinguaUtente) + " : " + DatiGenerali.PROGETTO, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}}]
          ArrayContenitore.push(RigaIntestazione)
          RigaIntestazione = [{v: this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_CALIBRAZIONE',this.LinguaUtente) + " : " + this.DataCalibrazione, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}}]
          ArrayContenitore.push(RigaIntestazione)
          // if (this.ObjAllineamento.DataAllineamento != null)
          // {
          //   RigaIntestazione = [{v: this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_ALLINEAMENTO',this.LinguaUtente) + " " + this.ObjAllineamento.PrettyDataAllineamento, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}}]
          //   ArrayContenitore.push(RigaIntestazione)
          // }

          let Row = 
          [
            // { v: this.GetTraduzioneLabel('Generic','TKN_MODULO',this.LinguaUtente) + " (" + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente) + ")", t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
            { v: this.GetTraduzioneLabel('Generic','TKN_DATA',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
            { v: this.GetTraduzioneLabel('Generic','TKN_PITCH',this.LinguaUtente) + " (" + this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) + ")", t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
            { v: this.GetTraduzioneLabel('Generic','TKN_ROLL',this.LinguaUtente) + " (" + this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) + ")", t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
            { v: this.GetTraduzioneLabel('Generic','TKN_YAW',this.LinguaUtente) + " (" + this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) + ")", t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
            { v: this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente) + " (" + this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente) + ")", t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
            { v: this.GetTraduzioneLabel('VUEComponenteGraficoSpostamenti','TKN_GRAF_SPOST_LV_FALDA',this.LinguaUtente) + " (" + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI_PIANO_CAMPAGNA',this.LinguaUtente) + ")", t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
          ];
          
          if (this.IsEstensimetroPresente)
            Row.push({ v: this.GetTraduzioneLabel('Generic','TKN_DEFORMAZIONE',this.LinguaUtente) + " (" + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ")", t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}})

          ArrayContenitore.push(Row)

          for (let k = 0; k < SingleModulo.Dati.length; k++)
          {
            let Elemento = SingleModulo.Dati[k]
            let DataFormattata = TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', new Date(Elemento.Data)) 
            let RowElemento = 
            [
              { v: DataFormattata, t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' }}},
              { v: Elemento.Pitch       == null ? '(null)' : (parseFloat(Elemento.Pitch)).toFixed(2),       t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
              { v: Elemento.Roll        == null ? '(null)' : (parseFloat(Elemento.Roll)).toFixed(2),        t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
              { v: Elemento.Yaw         == null ? '(null)' : (parseFloat(Elemento.Yaw)).toFixed(2),         t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
              { v: Elemento.Temperatura == null ? '(null)' : (parseFloat(Elemento.Temperatura)).toFixed(2), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
              { v: Elemento.Piezo       == null ? '(null)' : (parseFloat(Elemento.Piezo)).toFixed(2),       t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
            ];
            
            if (this.IsEstensimetroPresente)
              RowElemento.push({ v: Elemento.Deformazione == null ? '(null)' : (parseFloat(Elemento.Deformazione)).toFixed(2), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' }}})

            ArrayContenitore.push(RowElemento)
          }

          const ws = XLSX.utils.aoa_to_sheet(ArrayContenitore);
          XLSX.utils.book_append_sheet(wb, ws, this.GetTraduzioneLabel('Generic','TKN_MODULO',this.LinguaUtente) + ' ' + SingleModulo.Id);

          var wscols = [
                          {wch:50},
                          {wch:20},
                          {wch:20},
                          {wch:20},
                          {wch:20},
                          {wch:25},
                        ];

          if (this.IsEstensimetroPresente)
            wscols.push({wch:25})
                        
          ws['!cols'] = wscols;          
        }                
      }

      XLSX.writeFile(wb, this.DatiGenerici.DESCRIZIONE + '_' + Dati[0].Intervallo + ".xlsx");      
    },

    EsportaExcelSpostamentiGiornalieri(Dati)
    {
      const wb = XLSX.utils.book_new();
      // I TOTALI HANNO ALCUNI PUNTI IN PIù RISPETTO AI SINGOLI GRAFICI
      Dati[0].Grafici[0].GruppiPunti[0].Punti.splice(0, 1)

      for (let i = 0; i < Dati[0].Grafici.length; i++)
      {
        let ArrayContenitore = []
        let DatiGenerali = this.DatiGenerici
        let RigaIntestazione = [{v: this.GetTraduzioneLabel('Generic','TKN_DMS',this.LinguaUtente) + " " + DatiGenerali.DESCRIZIONE, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}}]
        ArrayContenitore.push(RigaIntestazione)
        RigaIntestazione = [{v: Dati[0].Intervallo, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}}]
        ArrayContenitore.push(RigaIntestazione)
        RigaIntestazione = [{v: this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_PROGETTO',this.LinguaUtente) + " : " + DatiGenerali.PROGETTO, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}}]
        ArrayContenitore.push(RigaIntestazione)
        RigaIntestazione = [{v: this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_CALIBRAZIONE',this.LinguaUtente) + " : " + this.DataCalibrazione, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}}]
        ArrayContenitore.push(RigaIntestazione)

        let Grafico = Dati[0].Grafici[i].GruppiPunti[0]
        let SpostGiornaliero = 0
        let DataStart = ''
        let LastSpostGiornaliero = null
        let Differenza = null
        let Contatore = 0

        let Row = 
        [
          // { v: this.GetTraduzioneLabel('Generic','TKN_MODULO',this.LinguaUtente) + " (" + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente) + ")", t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
          { v: this.GetTraduzioneLabel('Generic','TKN_DATA',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
          { v: this.GetTraduzioneLabel('Generic','TKN_SPOSTAMENTO',this.LinguaUtente) + " (" + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ")", t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
          { v: this.GetTraduzioneLabel('Generic','TKN_DIFFERENZA',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
        ];
        
        ArrayContenitore.push(Row)

        for (let k = 0; k < Grafico.Punti.length; k++)
        {     
          let Data  = Grafico.Punti[k].X
          let Spost = Grafico.Punti[k].Y

          if (DataStart == '')
            DataStart = Data
          if (Grafico.Punti[k].Y != null)
          {
            SpostGiornaliero += Spost
            Contatore++
          }
          if (Grafico.Punti[k].X.substring(0,10) != DataStart.substring(0,10))
          {
            if (SpostGiornaliero != null && LastSpostGiornaliero != null)
            {
              Differenza = (parseFloat((SpostGiornaliero / Contatore).toFixed(2)) - parseFloat((LastSpostGiornaliero / Contatore).toFixed(2)))
            }

            let DataStartFormattata = TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', new Date(DataStart)) 
            let RowElemento = 
            [ 
              { v: DataStartFormattata.substring(0,10), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' }}},              
              { v: SpostGiornaliero == null ? '(null)' : (parseFloat(SpostGiornaliero / Contatore)).toFixed(2), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
              { v: Differenza == null ? '(null)' : (Differenza).toFixed(2), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
            ];
            
            ArrayContenitore.push(RowElemento)            
            
            LastSpostGiornaliero = SpostGiornaliero
            SpostGiornaliero = 0
            Contatore = 0
            DataStart = Data
            Differenza = null
          }          
        }

        const ws = XLSX.utils.aoa_to_sheet(ArrayContenitore);
        let NomeScheda = Dati[0].Grafici[i].Id == -1 ? this.GetTraduzioneLabel('Generic','TKN_TOTALE',this.LinguaUtente) : this.GetTraduzioneLabel('Generic','TKN_MODULO',this.LinguaUtente) + ' ' + Dati[0].Grafici[i].Id
        XLSX.utils.book_append_sheet(wb, ws, NomeScheda);

        var wscols = [
                        {wch:40},
                        {wch:40},
                        {wch:40},
                        {wch:40}
                      ];
                      
        ws['!cols'] = wscols;          
      }     

      XLSX.writeFile(wb, this.DatiGenerici.DESCRIZIONE + '_' + Dati[0].Intervallo + ".xlsx");
    },
    
    EsportaExcelSpostamenti(Dati)
    {
      const wb = XLSX.utils.book_new();
      // I TOTALI HANNO ALCUNI PUNTI IN PIù RISPETTO AI SINGOLI GRAFICI
      Dati[0].Grafici[0].GruppiPunti[0].Punti.splice(0, 1)
      Dati[1].Grafici[0].GruppiPunti[0].Punti.splice(0, 1)
      Dati[2].Grafici[0].GruppiPunti[0].Punti.splice(0, 2)
      // if (!this.ObjXLSX.MediaOraria)
      // {
      //   for (let i = 0; i < Dati[0].Grafici.length; i++)
      //   {
      //     for (let j = 0; j < Dati[0].Grafici[j].length; j++)
      //     {
      //       let Grafico = Dati[0].Grafici[j].GruppiPunti[0]
      //       let SpostGiornaliero = 0
      //       let Contatore = 0
      //       let DataStart = ''
      //       let PuntiTmp = []
      //       for (let k = 0; k < Grafico.Punti.length; k++)
      //       {
      //         if (DataStart == '')
      //           DataStart = Grafico.Punti[k].X
      //         if (Grafico.Punti[k].Y != null)
      //         {
      //           SpostGiornaliero += Grafico.Punti[k].Y
      //           Contatore++
      //         }
      //         if ((new Date(Grafico.Punti[k].X)).getTime() >= (TZDateFunct.ChangeDate(DataStart, 'hour', 23)).getTime())
      //         {
      //           PuntiTmp.push({X: TZDateFunct.FormatDateTime('yyyy-mm-dd hh:nn', TZDateFunct.ChangeDate(DataStart, 'hour', 12)), Y: SpostGiornaliero / Contatore})
      //           SpostGiornaliero = 0
      //           Contatore = 0
      //           DataStart = Grafico.Punti[k].X
      //         }
      //       }
      //       Grafico.Punti = PuntiTmp
      //     }
      //   }
      // }

      for (let i = 0; i < Dati[0].Grafici.length; i++)
      {
        let SingleModuloSpost = Dati[0].Grafici[i]
        let SingleModuloVel   = Dati[1].Grafici[i]
        let SingleModuloAcc   = Dati[2].Grafici[i]
        let ArrayContenitore = []
        let DatiGenerali = this.DatiGenerici
        let RigaIntestazione = [{v: this.GetTraduzioneLabel('Generic','TKN_DMS',this.LinguaUtente) + " " + DatiGenerali.DESCRIZIONE, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}}]
        ArrayContenitore.push(RigaIntestazione)
        RigaIntestazione = [{v: Dati[0].Intervallo, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}}]
        ArrayContenitore.push(RigaIntestazione)
        RigaIntestazione = [{v: this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_PROGETTO',this.LinguaUtente) + " : " + DatiGenerali.PROGETTO, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}}]
        ArrayContenitore.push(RigaIntestazione)
        RigaIntestazione = [{v: this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_CALIBRAZIONE',this.LinguaUtente) + " : " + this.DataCalibrazione, t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, }, alignment:{ horizontal : 'center' }}}]
        ArrayContenitore.push(RigaIntestazione)

        let Row = 
        [
          // { v: this.GetTraduzioneLabel('Generic','TKN_MODULO',this.LinguaUtente) + " (" + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI',this.LinguaUtente) + ")", t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
          { v: this.GetTraduzioneLabel('Generic','TKN_DATA',this.LinguaUtente), t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
          { v: this.GetTraduzioneLabel('Generic','TKN_SPOSTAMENTO',this.LinguaUtente) + " (" + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ")", t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
          { v: this.GetTraduzioneLabel('Generic','TKN_VELOCITA',this.LinguaUtente) + " (" + this.GetTraduzioneLabel('UdmGenerali','TKN_MM_H',this.LinguaUtente) + ")", t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
          { v: this.GetTraduzioneLabel('Generic','TKN_ACCELERAZIONE',this.LinguaUtente) + " (" + this.GetTraduzioneLabel('UdmGenerali','TKN_MM_2H',this.LinguaUtente) + ")", t: "s", s: { font: { bold: true, name: 'Calibri', sz: 13, Width: 10, color: {rgb: 'ffffff'} }, alignment:{ horizontal : 'center' }, fill: {fgColor: {rgb: 'F18B53'}}}},
        ];
        
        ArrayContenitore.push(Row)

        for (let k = 0; k < SingleModuloSpost.GruppiPunti[0].Punti.length; k++)
        {     
          let Data  = SingleModuloSpost.GruppiPunti[0].Punti[k].X
          Data = TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', new Date(Data))          
          let Spost = SingleModuloSpost.GruppiPunti[0].Punti[k].Y
          let Vel   = null
          let Acc   = null

          if (k > 0)
          {
            if(SingleModuloVel.GruppiPunti[0].Punti[k - 1] != undefined)
              Vel = SingleModuloVel.GruppiPunti[0].Punti[k - 1].Y
            if (k > 1 && SingleModuloAcc.GruppiPunti[0].Punti[k - 2] != undefined)
              Acc = SingleModuloAcc.GruppiPunti[0].Punti[k - 2].Y
          }


          let RowElemento = 
          [
            { v: Data, t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' }}},              
            { v: Spost == null ? '(null)' : (parseFloat(Spost)).toFixed(2), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
            { v: Vel == null ? '(null)' : (parseFloat(Vel)).toFixed(2), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
            { v: Acc == null ? '(null)' : (parseFloat(Acc)).toFixed(2), t: "s", s: {font: {bold: false,name: 'Calibri', sz: 10  }, alignment: { horizontal : 'right' },}},
          ];
          
          ArrayContenitore.push(RowElemento)
        }

        const ws = XLSX.utils.aoa_to_sheet(ArrayContenitore);
        let NomeScheda = SingleModuloSpost.Id == -1 ? this.GetTraduzioneLabel('Generic','TKN_TOTALE',this.LinguaUtente) : this.GetTraduzioneLabel('Generic','TKN_MODULO',this.LinguaUtente) + ' ' + SingleModuloSpost.Id
        XLSX.utils.book_append_sheet(wb, ws, NomeScheda);

        var wscols = [
                        {wch:40},
                        {wch:30},
                        {wch:30},
                        {wch:30}
                      ];
                      
        ws['!cols'] = wscols;          
      }     

      XLSX.writeFile(wb, this.DatiGenerici.DESCRIZIONE + '_' + Dati[0].Intervallo + ".xlsx");      
    },

    OnClickConfermaModal()
    {
      let Self = this
      let Parametri = {}
      Parametri.IsCampioniRilevati = this.ObjXLSX.IsCampioniRilevati
      Parametri.FusoUtente = SystemInformation.UserInformation.FusoOrario
      Parametri.DataDal = this.Filtro.DallaData + ' ' + (this.Filtro.OreDal < 10 ? '0' + this.Filtro.OreDal : this.Filtro.OreDal) + ':00'
      Parametri.DataAl  = this.Filtro.AllaData + ' ' + (this.Filtro.OreAl < 10 ? '0' + this.Filtro.OreAl : this.Filtro.OreAl) + ':00'
      Parametri.ChiaveSito = this.ChiaveSito
      Parametri.ChiaveCatena = this.ChiaveCatena
      Parametri.ModuliConsiderati = this.ObjXLSX.Moduli.filter((element) => {return element.Selezionato})
      Parametri.Orientamento = this.ObjXLSX.OrientazioneAsse
      Parametri.IsOraria = this.ObjXLSX.MediaOraria
      Parametri.SoloTotale = this.ObjXLSX.SoloTotale
      Parametri.TuttiIDati = this.ObjXLSX.TuttiIDati
      Parametri.IntervalloMedia = this.ObjXLSX.IntervalloMedia

      SystemInformation.AdvQuery.ExecuteExternalScript('GetDataXLSXStorici', Parametri, function(Answer) 
      {
        if (Self.ObjXLSX.IsCampioniRilevati)
          Self.EsportaExcelCampioniRilevati(Answer.Dati)
        else
        {
          if (Parametri.IsOraria)
            Self.EsportaExcelSpostamenti(Answer.Dati)
          else
            Self.EsportaExcelSpostamentiGiornalieri(Answer.Dati)
        }
        Self.OnClickChiudiModal()
      },
      function(ErrorMessage,DescrErrore)
      {
        alert(ErrorMessage + '[' + DescrErrore + ']')
        Self.OnClickChiudiModal()
      })
    },

    OnClickSelezionaTuttiModuli()
    {
      if(this.FiltraModuli.length != 0)
      {
        this.FiltraModuli.forEach(function(Modulo)
        { 
            Modulo.Selezionato = true
        });
      }
    },

    OnClickDeselezionaTuttiModuli()
    {
      if(this.FiltraModuli.length != 0)
      {
        this.FiltraModuli.forEach(function(Modulo)
        { 
            Modulo.Selezionato = false
        });
      }
    },

    OnClickInvertiTuttiModuli()
    {
      if(this.FiltraModuli.length != 0)
      {
        this.FiltraModuli.forEach(function(Modulo)
        { 
            Modulo.Selezionato = !Modulo.Selezionato
        });
      }
    },

    OnClickPopupFiltroProfondita()
    {
      this.PopupFiltroProfondita = true
    },

    ConfermaFiltroProfondita()
    {
      this.Filtro.Profondita      = true
      this.FiltroProfonditaAttivo = true
      this.PopupFiltroProfondita  = false
    },

    AnnullaFiltroProfondita()
    {
      this.PopupFiltroProfondita = false
    },

    OnClickResetFiltroProfondita()
    {
      this.Filtro.DallaProfondita = 0
      this.Filtro.AllaProfondita  = 0
      this.Filtro.Profondita      = false
      this.FiltroProfonditaAttivo = false
    },

    CalcolaGrandezzaDivPulsanti()
    {
      this.GrandezzaDivPulsanti.Height = this.$refs.DivPulsanti.clientHeight
    },

    ControlloDateInserite()
    {
      if(this.Filtro.DallaData != '' && this.Filtro.AllaData != '' && this.Filtro.OreDal !== '' && this.Filtro.OreAl !== '')
      {
        if(this.Filtro.DallaData + ' ' + this.Filtro.OreDal < this.Filtro.AllaData + ' ' + this.Filtro.OreAl)
          return true
      }
      return false
    },

    ControlloModuliSelezionati()
    {
      for(let i = 0; i < this.FiltraModuli.length; i++)
      {
        if(this.FiltraModuli[i].Selezionato)
          return true
      }
      return false
    },

    CanRecord()
    {
      return this.ControlloDateInserite() &&
             this.ControlloModuliSelezionati()
             
    },

    GestisciDateGrafica(Data)
    {
      return TZDateFunct.FormatDateTime('dd/mm/yyyy', new Date(Data))
    },

    ApparePeriodoMedia()
    {
      return this.TipologiaPopup == this.TipologiaGrafici.CAMPIONI_RILEVATI ||
             this.TipologiaPopup == this.TipologiaGrafici.SPOSTAMENTI_GRAFICI_SEPARATI ||
             this.TipologiaPopup == this.TipologiaGrafici.VELOCITA_MEDIA_ORARIA ||
             this.TipologiaPopup == this.TipologiaGrafici.VELOCITA_MEDIA_GIORNALIERA ||
             this.TipologiaPopup == this.TipologiaGrafici.ACCELERAZIONE_MEDIA_ORARIA ||
             this.TipologiaPopup == this.TipologiaGrafici.ACCELERAZIONE_MEDIA_GIORNALIERA
    },

  },
  
  computed:
  {
    FiltraModuli :
    {
      get()
      {
        let Self   = this
        let Result = []
        Result = this.ObjXLSX.Moduli
        if(this.Filtro.Estensimetri || this.Filtro.Piezometri || this.Filtro.Profondita)
        {
          Result = Result.filter(function(Modulo)
          {
            let ProfonditaModulo  = parseFloat(Modulo.Profondita)
            let ProfonditaMinima  = parseFloat(Self.Filtro.DallaProfondita)
            let ProfonditaMassima = parseFloat(Self.Filtro.AllaProfondita)
            if(Self.Filtro.Piezometri && Modulo.Piezometro)
              return true
            if(Self.Filtro.Estensimetri && Modulo.Estensimetro)
              return true
            if(Self.Filtro.Profondita && (ProfonditaMassima < ProfonditaMinima) && (ProfonditaMassima <= ProfonditaModulo) && (ProfonditaModulo <= ProfonditaMinima))
              return true
            if(Self.Filtro.Profondita && (ProfonditaMinima < ProfonditaMassima) && (ProfonditaMinima <= ProfonditaModulo)  && (ProfonditaModulo <= ProfonditaMassima))
              return true
            return false
          })
        }

        return Result
      }
    }
  },

  beforeMount()
  {
    this.Filtro.AllaData  = this.ObjXLSX.Al.Data
    this.Filtro.DallaData = this.ObjXLSX.Dal.Data
    this.Filtro.OreAl  = this.ObjXLSX.Al.Ora
    this.Filtro.OreDal = this.ObjXLSX.Dal.Ora
  },

  mounted()
  {
    this.CalcolaGrandezzaDivPulsanti()
  },

  watch:
  {
    'Filtro.OrientamentoAsse': 
      function (newValue) 
      {
        if(newValue != '')
        {
          if (isNaN(newValue)) 
            this.Filtro.OrientamentoAsse = 0;
          else this.Filtro.OrientamentoAsse = Math.max(0, Math.min(359.99, parseFloat(newValue)));
        }
      },
  },
}
</script>